import { Token } from 'elephantswapv3-sdk-core'

export class UserAddedToken extends Token {}
